import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { applicationConfiguration, AppConfig } from '../interceptor/app.config';
import { secureStorage } from './secure-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  protected server = this.appConfig.apiUrl + 'api/eol/v1/pv/';
  protected server2 = this.appConfig.apiUrl + 'api/eol/';
  private dataSubject = new BehaviorSubject<any>(null);
  currentData = this.dataSubject.asObservable();
  
  private setBillingAddress = new BehaviorSubject<any>(null);
  currentBillingAddress = this.setBillingAddress.asObservable();

  private setShippingAddress = new BehaviorSubject<any>(null);
  currentShippingAddress = this.setShippingAddress.asObservable();



  readonly options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    }),
  };
  
  constructor(
    private http: HttpClient,
    private localstorage: secureStorage,
    @Inject(applicationConfiguration) private appConfig: AppConfig
  ) { }
  getUserDetails(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/user_profile/`, payload, this.options);
  }

  updateAdress(product: any): Observable<any> {
    return this.http.post(`${this.server}account/update_default_address/`, product, this.options);
  }
  
  bannerList(product: any): Observable<any> {
    return this.http.post(`${this.server}account/get_banner_list/`, product, this.options);
  }

  guideSearch(product: any): Observable<any> {
    return this.http.post(`${this.server}search/get_guided_search/`, product, this.options);
  }


   createMostSearchPart(product: any): Observable<any> {
    return this.http.post(`${this.server}account/create_most_search_part/`, product, this.options);
  }

    getFilters(product: any): Observable<any> {
    return this.http.post(`${this.server}common/get_filter_dropdown/`, product, this.options);
  }


  sendOtp(product: any): Observable<any> {
    return this.http.post(`${this.server}account/send_otp/`, product, this.options);
  }

  verifyOtp(product: any): Observable<any> {
    return this.http.post(`${this.server}account/login_verify_otp/`, product, this.options);
  }

  userRegistration(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/user_registration/`, payload, this.options);
  }

  getProductlistData(payload: any): Observable<any> {
    return this.http.post(`${this.server}search/part_search/`, payload, this.options);
  }

  getProductDetailData(payload: any): Observable<any> {
    return this.http.post(`${this.server}search/part_detail/`, payload, this.options);
  }

  addToCart(payload: any): Observable<any> {
    return this.http.post(`${this.server}cart/cart/`, payload, this.options);
  }

  getCartData(payload: any): Observable<any> {
    return this.http.post(`${this.server}cart/cart/`, payload, this.options);
  }

  getBuyNowPriceBreakup(payload: any): Observable<any> {
    return this.http.post(`${this.server}cart/get_buy_now_price_breakup/`, payload, this.options);
  }
  removeCartData(payload: any): Observable<any> {
    return this.http.post(`${this.server}cart/remove_cart/`, payload, this.options);
  } 


  addToWishlist(payload: any): Observable<any> {
    return this.http.post(`${this.server}cart/wishlist/`, payload, this.options);
  }

  getWishlistData(payload: any): Observable<any> {
    return this.http.post(`${this.server}cart/wishlist/`, payload, this.options);
  }   

  updateSendOtp(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/update_send_otp/`, payload, this.options);
  }

  updateVerifyOtp(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/update_user_verify_otp/`, payload, this.options);
  }

  getAddressData(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/user_address_list/`, payload, this.options);
  } 

  addAddress(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/add_user_address/`, payload, this.options);
  }

  getGstdata(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/get_gst_details/`, payload, this.options);
  }

  addGstdata(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/add_user_address/`, payload, this.options);
  }

  updateAddressdata(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/update_default_address/`, payload, this.options);
  }

  dataBypincode(payload: any): Observable<any> {
    return this.http.post(`${this.server}search/geo_dropdowns/`, payload, this.options);
  }

  geoLocation(payload: any): Observable<any> {
    return this.http.post(`${this.server}search/get_pincode_by_lat_lon/`, payload, this.options);
  }

  getadvancePartSearch(payload: any): Observable<any> {
    return this.http.post(`${this.server}search/advance_part_search/`, payload, this.options);
  }


  buyNow(payload: any): Observable<any> {
    return this.http.post(`${this.server}order/create_order/`, payload, this.options);
  }

  cancelOrder(payload: any): Observable<any> {
    return this.http.post(`${this.server}order/cancellation_request/`, payload, this.options);
  }

ratingOrder(payload: any): Observable<any> {
    return this.http.post(`${this.server}order/invoice_feedback/`, payload, this.options);
  }

  faqList(payload: any): Observable<any> {
    return this.http.post(`${this.server}common/get_faq_list/`, payload, this.options);
  }

  
  getRecentlyViewedProductlistData(payload: any): Observable<any> {
    return this.http.post(`${this.server}cart/recently_viewed_items/`, payload, this.options);
  }

    customerFeddback(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/get_customer_rating/`, payload, this.options);
  
  }

  enquiryNow(payload: any): Observable<any> {
    // If payload is FormData, don't set Content-Type header (let browser set it automatically)
    if (payload instanceof FormData) {
      return this.http.post(`${this.server}account/create_enquiry/`, payload);
    }
    // For regular JSON payloads, use the default options
    return this.http.post(`${this.server}account/create_enquiry/`, payload, this.options);
  }

  getBlogs(payload: any): Observable<any> {
    return this.http.post(`${this.server}admin/get_blog_list/`, payload, this.options);
  
  }


  getBrand(payload: any): Observable<any> {
    return this.http.post(`${this.server}common/vehicle_mapping_dropdowns/`, payload, this.options);
  
  }     

  getVehicle(payload: any): Observable<any> {
    return this.http.post(`${this.server}common/vehicle_mapping_dropdowns/`, payload, this.options);
  
  }

    AddVehicle(payload: any): Observable<any> {
    return this.http.post(`${this.server}common/vehicle_mapping_dropdowns/`, payload, this.options);

  }

  createGarage(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/create_garage/`, payload, this.options);

  }
   get_garage (payload: any): Observable<any> {
    return this.http.post(`${this.server}account/get_garage/`, payload, this.options);

  }

  getorderlist(payload: any): Observable<any> {
    return this.http.post(`${this.server}order/invoice/`, payload, this.options);
  
  }
   get_category(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/get_category/`, payload, this.options);
  }

   getModelSearch(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/get_most_search_part/`, payload, this.options);
  }
 
  addModelSearch(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/create_most_search_part/`, payload, this.options);
  }

  user_logout(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/user_logout/`, payload, this.options);
  }
  getOrderDetail(payload: any): Observable<any> {
    return this.http.post(`${this.server}order/order_details/`, payload, this.options);
  }


  requestCallBack(payload: any): Observable<any> {
    return this.http.post(`${this.server}order/customer_support/`, payload, this.options);
  }

  getFaqData(payload: any): Observable<any> {
    return this.http.post(`${this.server}common/get_faq_list/`, payload, this.options);
  }

  submitReturnRequest(payload: any): Observable<any> {
    return this.http.post(`${this.server}order/return_request/`, payload, this.options);
  }




  add_scrap_certificate(formData: FormData): Observable<any> {
    // For FormData, we need to remove the default headers and let the browser set Content-Type
    const formDataOptions = {
      headers: {
        // Don't set Content-Type, let browser set it with boundary for multipart/form-data
      }
    };
    return this.http.post(`${this.server}account/add_scrap_certificate/`, formData, formDataOptions);
  }

  getScrapCertificateList(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/get_scrap_certificates/`, payload, this.options);
  }

  checkScrapCategoryMatch(payload: any): Observable<any> {
    return this.http.post(`${this.server}account/get_scrap_certificates/`, payload, this.options);
  }

  uploadReturnImage(payload: any): Observable<any> {
    // If payload is FormData, don't set Content-Type header (let browser set it automatically)
    if (payload instanceof FormData) {
      return this.http.post(`${this.server}order/upload_return_images/`, payload);
    }
    // For regular JSON payloads, use the default options
    return this.http.post(`${this.server}order/upload_return_images/`, payload, this.options);
  }
  
}
